"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.header = exports.content = exports.closeButton = exports.base = void 0;

var _util = require("../../../util");

const drawerHeight = 56;
const minimisedHeaderHeight = 64;
const transition = 'all 0.2s ease';

const base = ({
  cssProps,
  theme
}) => {
  const {
    transitionState = 'mounted',
    isMinimised,
    hasMiniHeader,
    zIndex,
    offset
  } = cssProps;
  const isMounted = transitionState === 'mounted';
  let translateValue = '100%';

  if (isMounted) {
    if (!isMinimised) {
      translateValue = '0px';
    } else if (!hasMiniHeader) {
      translateValue = "calc(100% - ".concat(drawerHeight, "px)");
    } else if (hasMiniHeader) {
      translateValue = "calc(100% - ".concat(minimisedHeaderHeight, "px)");
    }
  }

  return {
    transition,
    background: (0, _util.color)(theme, theme.modals.background),
    borderRadius: (0, _util.spacing)(theme, ['medium', 'medium', 0, 0]),
    transform: "translateY(".concat(translateValue, ")"),
    height: "calc(100% - ".concat(offset, "px)"),
    width: '100%',
    position: 'absolute',
    bottom: 0,
    left: 0,
    alignSelf: 'flex-end',
    zIndex
  };
};

exports.base = base;

const closeButton = ({
  theme
}) => {
  const marginLeft = (0, _util.spacing)(theme, 'xsmall');
  return {
    // alignment correction
    marginLeft: -marginLeft,
    marginRight: (0, _util.spacing)(theme, 'small')
  };
};

exports.closeButton = closeButton;

const content = ({
  theme
}) => ({
  flex: 1,
  backgroundAttachment: 'local, scroll',
  backgroundImage: "linear-gradient(0deg, ".concat((0, _util.color)(theme, theme.modals.background), " 0px 2px, transparent 2px), linear-gradient(0deg, transparent 0px 0.5px, ").concat((0, _util.color)(theme, theme.modals.borderColor), " 0.5px 1.5px, transparent 1.5px)"),
  height: '100%',
  overflowY: 'auto'
});

exports.content = content;

const header = ({
  theme,
  cssProps
}) => {
  const {
    isMinimised,
    isContentScrolled
  } = cssProps;
  return {
    transition,
    height: isMinimised ? minimisedHeaderHeight : drawerHeight,
    padding: (0, _util.spacing)(theme, ['small', 'medium']),
    borderRadius: (0, _util.spacing)(theme, ['medium', 'medium', 0, 0]),
    backgroundColor: isMinimised ? (0, _util.color)(theme, theme.modals.backgroundMinimised) : 'none',
    borderBottom: "1px solid ".concat((0, _util.color)(theme, isContentScrolled ? 'ui3' : 'transparent'))
  };
};

exports.header = header;
//# sourceMappingURL=Drawer.style.js.map